import { Component, Input } from '@angular/core';
import { AmbassadorPin } from '@shared/interfaces/pins.interface';

@Component({
    selector: 'app-map-infowindow-ambassador',
    templateUrl: './map-infowindow-ambassador.component.html'
})
export class MapInfoWindowAmbassadorComponent {
    @Input() pin: AmbassadorPin;
}
